import Vue from 'vue'
import { mapState } from 'vuex'
export default {
    computed: {
        ...mapState(["groupTeamArr"]),
    },
    methods: {
        
        strSliceStarAndEndT (str = '', max, end, tag = '...') {
            return str.length > max ? this.formatStringSubstrT(str, { s: 0, e: end }, tag) + str.substr(-(max - end)) : str
        },
        formatStringSubstrT (str = '', { s, e }, tag = '...') {
            if (typeof str !== 'string') return ''
            return str.substring(s, e) + tag
        },
        
        isLastIndexT (arr, index) {
            return arr.length === index + 1
        },

        
        equalIs(l, r) {
            return l === r;
        },
        getArrayLastItem(arr) {
            return arr.slice(-1)[0]
        },
        getItemOfArray(arr, index = 0) {
            return arr.slice(index)[0]
        },
        replaceStrT(str, serch, value) {
           return str.replace(serch, value)
        },
        
        isHeaderPathChangeT (arr, obj, judge) {
            this.l$({ arr, obj, judge }, 'isChange')
            if (obj.type === 'cloud') return false
            return !(arr.slice(-1)[0].query[judge] === obj.query[judge])
        },
        groupsNameT (data) {
            if(data.openStatus === "public"){
                return Vue.prototype.$t("group.all_my_group");
            }
            return data.openStatus !== "group"
                ? Vue.prototype.$t( "code-lab/component/file-management/mixins/tool-mix.js_0" )
                : data.groups.reduce(
                    (a, b) =>
                    a +
                    (a ? "," : "") +
                    this.groupTeamArr.find(fo => fo.groupId === b) && typeof this.groupTeamArr.find(fo => fo.groupId === b) === 'object' && this.groupTeamArr.find(fo => fo.groupId === b).groupName || '',
                    ""
                )
        },
        isFolderT (data) {
            return data.type$ === '_id'
        },
        isTypeOfFileT (data, type) {
            return data.openStatus === type
        },
        downloadToComputerT (url) {
            const elmA = document.createElement("a")
            elmA.setAttribute("href", url)
            if (window.navigator && window.navigator.userAgent.indexOf("Firefox") > -1) {
                elmA.setAttribute("target", "_blank")
            }
            document.body.appendChild(elmA)
            elmA.click()
            document.body.removeChild(elmA)
        },
    },
}